import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PhysicianCouncils, PhysicianCouncilsData } from '../../../interfaces/masters/physician-councils';
import { PhysicianCouncilsApi } from '../api/physician-councils.api';

@Injectable()
export class PhysicianCouncilsService extends PhysicianCouncilsData{

 
  constructor(private api: PhysicianCouncilsApi) { 
    super(); 
  }

  
  list(url: string): Observable<PhysicianCouncils[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<PhysicianCouncils>{
      return this.api.getById(url); 
  }

  create(url: string, data:PhysicianCouncils[]): Observable<PhysicianCouncils> {
    return this.api.add(url,data);
    
  }

  update(url: string, data:PhysicianCouncils): Observable<PhysicianCouncils> {
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  } 

}
